const variables = {
  id: "variables",
  label: "Variables",
  endpoint: "variables",
  columnConfig: [
    {
      field: "name",
      headerName: "Variable",
      width: 250,
      description: "Variable",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default variables;
